import { useEffect, useState } from "react"
import { generatePath } from "react-router-dom"
import { ContentBox, FileDropZone, ImportErrors } from "web/components"
import { useCurrentTLO } from "web/hooks/context"
import { useImports } from "web/hooks/data"
import ImportsList from "./ImportsList"

export default function SubjectImportList({
  typeSelect = "multi_topic_record",
  showUrl,
}) {
  const [doingWork, setDoingWork] = useState(false)
  const [isUploading, setIsUploading] = useState(false)
  const [errors, setErrors] = useState([])

  const { data: subject } = useCurrentTLO()

  const imports = useImports({
    type: typeSelect,
    subject: subject,
    swrOptions: {
      refreshInterval: doingWork ? 2000 : 0,
    },
  })

  const importsDoingWork = imports.some((importObj) => importObj.doing_work)

  useEffect(() => {
    setDoingWork(importsDoingWork)
  }, [importsDoingWork])

  async function handleFilesSelected(files) {
    setIsUploading(true)
    const currentLocation = window.location.pathname
    const formData = new FormData()

    formData.append("file", files[0])
    formData.append("type", typeSelect)
    formData.append("subject_id", subject.id)
    formData.append("subject_type", subject.resource_type)

    try {
      const importObj = await imports.add(formData)
      if (currentLocation === window.location.pathname) {
        window.Turbo.visit(generatePath(showUrl, { id: importObj.id }))
      }
    } catch (error) {
      setErrors(error.response.data.errors)
      setIsUploading(false)
    }
  }

  return (
    <div className="mt-3">
      <ContentBox>
        <h2 className="text-2xl font-bold">Import Data</h2>
        <p className="mt-5 text-sm">
          Your import must be an Excel file. We'll attempt to import data from
          sheets in your workbook prefixed with 'Origin&gt;'.
        </p>
        <h3 className="mt-5 text-lg font-bold">New Import</h3>
        <div className="mt-4">
          <FileDropZone
            disabled={isUploading}
            onFilesDropped={handleFilesSelected}
          />
        </div>
        <ImportErrors errors={errors} />
        <>
          <div className="mt-4">
            <ImportsList imports={imports} showUrl={showUrl} />
          </div>
        </>
      </ContentBox>
    </div>
  )
}
